import { render, staticRenderFns } from "./chose-template.vue?vue&type=template&id=6ebe61d3&scoped=true"
import script from "./chose-template.vue?vue&type=script&lang=js"
export * from "./chose-template.vue?vue&type=script&lang=js"
import style0 from "./chose-template.vue?vue&type=style&index=0&id=6ebe61d3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebe61d3",
  null
  
)

export default component.exports